<script>
	import model from "../../stores/modelStore";
	import { projectSettings } from "../../config";
	import { registerFormStart } from "../../tealium";

	import PageSection from "../../components/PageSection.svelte";
	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import Checkbox from "../../components/Checkbox.svelte";

	export let pageTitle = null;
	export let lastVisitedPage = null;
	export let disabled = null;

	let buttons;

	if (!disabled) {
		$model.LastPageVisited = lastVisitedPage;
		document.title = pageTitle;

		//  Get the user Agent
		$model.UserAgent = navigator.userAgent;
		$model.referrer = document.referrer;
		$model.RegistrationSegmentId = null;
	}

	const handleSubmit = (e) => {
		buttons.blockNext();

		e.preventDefault();
		grecaptcha.ready(function () {
			grecaptcha.execute(projectSettings.gSiteKey3, { action: "submit" }).then(async function (token) {
				let options = {
					method: "POST",
					headers: {
						"Content-type": "application/json"
					},
					body: JSON.stringify({ token: token })
				};

				var url = `${projectSettings.basePath}api/gverify`;
				let response = await fetch(`${url}`, options);
				if (response.ok) {
					let data = await response.json();

					if (data && data.status === true) {
						await registerFormStart();

						buttons.next();
						buttons.unblock();
						return true;
					}

					grecaptcha.render(document.getElementById("g-recaptcha"), {
						sitekey: projectSettings.gSiteKey2,
						callback: reCaptchaV2
					});
				}

				return false;
			});
		});
	};

	const reCaptchaV2 = async (token) => {
		let options = {
			method: "POST",
			headers: {
				"Content-type": "application/json"
			},
			body: JSON.stringify({ token: token })
		};

		let url = `${projectSettings.basePath}api/gverifyv2`;
		let response = await fetch(`${url}`, options);
		let data = await response.json();

		if (data.status) {
			await registerFormStart();

			buttons.next();
			buttons.unblock();
		}
	};
</script>

<PageSection>
	<Form id="form-landing-page" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h1 class="text-center">Register your interest in the Victorian Childcare Concerns Investigation</h1>
			</FormColumn>
		</FormRow>

		<hr class="primary" />

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					Shine Lawyers is actively investigating claims, including the potential for a group action, in response to serious assault allegations involving a former childcare worker, Joshua Dale Brown.
				</p>
				<p>
					For more information on the investigation, please visit our <a href="https://www.shine.com.au/service/survivors-of-abuse/victorian-childcare-concerns" target="_blank">website</a>.
				</p>
				<p>
					If this has affected you or your family, you can begin a confidential, no-obligation enquiry at no cost, by clicking the button below.
				</p>
			</FormColumn>
		</FormRow>

		<div class="confirmation-box-shadow">
			<FormRow>
				<FormColumn>
					<p class="mb-3">
						Do you agree to provide us with personal information which will be kept confidential under the
						Shine Lawyers
						<a href="https://www.shine.com.au/privacy-policy" title="Privacy Policy" target="_blank"
							>Privacy Policy</a
						>?
					</p>
					<Checkbox
						required="true"
						{disabled}
						bind:checked={$model.privacyPolicyConfirmed}
						label="I agree to the privacy policy"
						id="privacy"></Checkbox>
				</FormColumn>
			</FormRow>
		</div>

		<FormRow class="justify-content-md-center register-btn confirmation-hide">
			<FormColumn class="text-center" cols="12">
				<NavigationButtons
					showPrevious={false}
					bind:buttons
					nextPageLabel="REGISTER MY INTEREST"
					disableNext={!$model.privacyPolicyConfirmed}></NavigationButtons>
			</FormColumn>
			<FormColumn cols="12">
				<div class="recaptcha">
					<div id="g-recaptcha" data-sitekey={projectSettings.gSiteKey2}></div>
				</div>
			</FormColumn>
		</FormRow>

		<FormRow class="justify-content-md-center confirmation-hide">
			<FormColumn>
				<p>
					If you have any immediate concerns or would like to speak confidentially, please contact our team by
					email at
					<ClassActionEmailAddress></ClassActionEmailAddress>.
				</p>
			</FormColumn>
		</FormRow>
	</Form>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	.recaptcha {
		padding-top: 20px;
		display: flex;
		justify-content: center;
	}

	.unbold {
		font-weight: normal;
	}

	ul {
		margin-left: 20px;
	}

	li {
		padding-left: 20px;
	}
</style>
